angular.module('swapick')
.controller('WantedCtrl', WantedCtrl);


function WantedCtrl($scope, DataService, DataStrategies, $ionicScrollDelegate,
   initialLoaderManager, $q, $timeout, $stateParams, $state, $ionicHistory,
   ReloadControllers) {

  this.type = $stateParams.type || 'oggetti';
  this.objects = [];

  this.toWanted = (type) => {
    $ionicHistory.nextViewOptions({ disableAnimate: true });
    $ionicHistory.currentView($ionicHistory.backView());
    $state.go('app.logged.wanted', {
        type : type
    }, { location:'replace'});
  }

  this.setupApi = () => {
    let method = this.type == 'oggetti' ? DataService.wanted : DataService.interests;

    DataStrategies.createPagerMethods(
      this, $scope,
      {
        method:method, callMethodName:'getList', pageSize:50, hasSearch:true,
        params: () => ({ q: this.searchString })
      }
    );
  }

  this.dropObject = (obj, idx) => {
    let method = this.type == 'oggetti' ? DataService.wanted : DataService.interests;
    method
    .one(obj.id.toString())
    .remove()
    .then(resp=>{
      this.objects.splice(idx, 1);
    })
  }



  this.loader = initialLoaderManager.makeLoader(()=> {
    return this.loadMore()
  }, false);


  $scope.$on('$ionicView.beforeEnter', () => {
      if (!this.objects.length){
        this.loader.load();
      } else {
        ReloadControllers.whenReload('WantedCtrl', () => {
          this.loader.load();
        });
      }
  });

  //For this to work, this controller must not be cached, or the type must be in the url.
  this.setupApi();

}



// WEBPACK FOOTER //
// ./src/controllers/wanted-controller.js